module.exports = __webpack_public_path__ + "static/img/introduce-m@2x.33e44d81.png";